module.exports = __webpack_public_path__ + "img/oct_22.9ab6537f.png";